var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSfund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSfund0)",
    d: "m9.372 6.921l2.83-3.021l.115 1.907c-.42.437-1.779 1.714-3.339 3.763c-1.388 1.821-.056 4.144.96 4.98v1.693c-.664-.36-1.873-.845-2.76-3.035c-1.097-2.7.866-4.748 2.194-6.287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSfund1)",
    d: "m14.7 16.937l-2.837 3.026l-.112-1.908c.42-.44 1.672-1.808 3.343-3.762c1.371-1.612 0-4.222-.96-4.766V7.85c.66.36 1.774.703 2.666 2.893c1.092 2.7-.643 4.963-2.1 6.193"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSfund2)",
    d: "M11.781 20.143c-1.328-1.226-3.33-4.56-.729-8.109l.995-1.307c.553-.746 1.243-2.807.021-4.496c-.15-.205-1.153-.904-1.894-.171l-.094.107l.094-.103l2.001-2.207c1.359 1.209 3.463 4.449 1.016 7.744l-1.286 1.663c-.467.664-1.127 2.529 0 4.697c.262.395 1.286.609 2.139-.343z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSfund0",
    x1: 11.992,
    x2: 11.992,
    y1: 3.857,
    y2: 20.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986EF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4592E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSfund1",
    x1: 12,
    x2: 12,
    y1: 20.143,
    y2: 3.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CD7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8651E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSfund2",
    x1: 12.051,
    x2: 12.051,
    y1: 3.857,
    y2: 20.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45CFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E68FC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfund);
export default __webpack_public_path__ + "static/media/sfund.db7398b4c2c029472cd5a7fe0f4af571.svg";
export { ForwardRef as ReactComponent };